import {Injectable} from '@angular/core';
import {Observable, tap} from 'rxjs';

import * as APIM from '@common/utils/dist/models/api-messages.js';
import {KeyUtilsPL2 as KU} from '@common/utils/dist/utils/key-utils-pl2.js';
import {UtilsPL2 as U} from '@common/utils/dist/utils/utils-pl2.js';

import {EventMatchStore} from '@stores/event-match.store';
import {EventAPIService, SendEventInput} from '@services/event-api.service';
import {ServiceDecorator} from './service-decorator';

@Injectable()
export class EventMatchDecorator
  implements EventAPIService, ServiceDecorator<EventAPIService>
{
  private _service: EventAPIService;

  constructor(private eventMatchStore: EventMatchStore) {}

  setService(service: EventAPIService): void {
    this._service = service;
  }

  sendEvent(input: SendEventInput): Observable<string | void> {
    if (U.isEmpty(this._service)) {
      throw new Error('[EventMatchDecorator]service not initialized');
    }

    return this._service.sendEvent(input).pipe(
      tap((trackingId) => {
        if (typeof trackingId !== 'string') return;
        const intent = input.eventType as APIM.EventIntent;
        const entries = (input as any).c;
        const pKs = Array.isArray(entries)
          ? entries
              .filter((e) => KU.isPrimaryKey(e))
              .map((e) => KU.stringFromKey(e))
          : [];
        if (pKs.length > 0) {
          this.eventMatchStore.publish(intent, trackingId, pKs);
        }
      }),
    );
  }
}
